var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 86.004a43.002 43.002 0 1 1 0-86.004 42.45 42.45 0 0 1 26.486 9.157.878.878 0 0 1-1.085 1.38 40.709 40.709 0 0 0-25.4-8.782A41.247 41.247 0 1 0 84.25 43.002a40.708 40.708 0 0 0-8.78-25.4.878.878 0 0 1 1.38-1.084 42.45 42.45 0 0 1 9.155 26.485 43.05 43.05 0 0 1-43.002 43.002h-.001z",
    fill: "#91D8AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.997 75.177A32.174 32.174 0 1 1 75.17 43.004a32.21 32.21 0 0 1-32.173 32.173zm0-62.593a30.418 30.418 0 1 0 30.418 30.42 30.453 30.453 0 0 0-30.418-30.42z",
    fill: "#91D8AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.997 64.347A21.343 21.343 0 1 1 64.34 43.004a21.369 21.369 0 0 1-21.343 21.343zm0-40.933a19.59 19.59 0 1 0 19.588 19.59 19.613 19.613 0 0 0-19.588-19.59z",
    fill: "#91D8AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.995 53.518a10.513 10.513 0 0 1-7.434-17.95 10.515 10.515 0 0 1 17.95 7.435 10.527 10.527 0 0 1-10.516 10.515zm0-19.273a8.76 8.76 0 1 0 8.76 8.759 8.77 8.77 0 0 0-8.76-8.759z",
    fill: "#91D8AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.639 46.238a.877.877 0 0 1-.62-1.498l25.847-25.848a.878.878 0 1 1 1.241 1.241l-25.85 25.848a.874.874 0 0 1-.62.257h.002z",
    fill: "#91D8AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 20.39h-7.213a.878.878 0 0 1-.878-.877v-7.214a.874.874 0 0 1 .258-.62L77.289.258a.877.877 0 0 1 1.497.62v6.335h6.335a.877.877 0 0 1 .62 1.498l-11.42 11.422a.876.876 0 0 1-.62.257zm-6.335-1.755h5.973l9.666-9.666h-5.095a.877.877 0 0 1-.878-.877V2.997l-9.666 9.665v5.973zM40.639 46.238a.877.877 0 0 1-.856-1.075l1.63-7.033a.877.877 0 0 1 1.71.395l-1.313 5.663 5.663-1.312a.88.88 0 0 1 .709 1.57.878.878 0 0 1-.313.14l-7.033 1.629a.891.891 0 0 1-.197.023z",
    fill: "#91D8AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.97c8f9766af24863a5a56e7d056cb887.svg";
export { ForwardRef as ReactComponent };